import React, {useState, useEffect, Fragment} from 'react';
import {ContactDetail, TextHighlight, AddButton, NewDeviceField, CheckIcon, UserIcon, BackButton, VisDiv, Photos,Loading, ViewLabelValueField, FieldDropdown} from '../components';
import { v4 as uuidv4, v4 } from 'uuid';
import { keyId } from '../lib/utils';
import { useStateContext } from '../context/StateContext';

const ContactDetails = ({contactDetails, saveFn}) => {

    const [addingNew, setAddingNew] = useState(false)
    const {LDB} = useStateContext();

    const contactDoc = {
        _id: uuidv4(),
        _key: keyId(),
        _type: "contactDetail",
        jobTitle: "",
        incarico: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        secondaryPhoneNumber: "",
    }
    const addContact = () => {
        //console.log("ADD CONTACT", contactDetails)
        setAddingNew(!addingNew)
        
    }
    
    const dottedBorder = {borderRight: 1, borderRightColor: "#d1c5c5", borderRightStyle: "dotted", backgroundColor: "#d3d2d4"}
    const headerStyle = {flex:1, padding:"8px", textAlign:"left", ...dottedBorder}
  return (
    <div>
        <div style={{marginBottom:"15px", display:"flex", justifyContent:"center", alignItems:"center", fontWeight: "bold"}}>
            <h2>{LDB("contacts", "contacts")}</h2>
        </div>
        {!Array.isArray(contactDetails) ? [] : contactDetails?.map?.((contact, index)=> {
        return(
            <ContactDetail saveFn={saveFn} headerStyle={headerStyle} index={index} key={contact?._key} contact={contact}/>
        )
    })  
    }
    <AddButton
        label={addingNew ? LDB("contacts", "close") : LDB("contacts", "addContact")}
        onClick={addContact}
    />
    <VisDiv rules={[addingNew]}>
        <ContactDetail 
            resetAfterSave={true} 
            noArchive={true} 
            alwaysEdit={true} 
            saveFn={saveFn}
            contact={contactDoc}
        />
    </VisDiv>
    </div>
  )
}

export default ContactDetails
